// Begin action types
export const CLEAR_DASHBOARD = 'CLEAR_DASHBOARD'
export const FETCH_DASHBOARD_SUCCESS = 'FETCH_DASHBOARD_SUCCESS'
// End action types

export const clearDashboard = () => ({
  type: CLEAR_DASHBOARD
});
export const fetchDashboardSuccess = (dashboard) => ({
  type: FETCH_DASHBOARD_SUCCESS,
  dashboard
});